import { Badge } from '@nextui-org/react';
import React from 'react';

const NumberComponent = ({ number, number1, number2, number3 }) => {
  return (
    <div className="flex  lg:justify-end justify-center md:h-[90px]">
      <div className="border rounded-md dark:border-dark-300 bg-white  dark:bg-dark-300 ">
        <div className=" dark:border-dark-100 w-full ">
          <div className="grid grid-cols-4  text-center font-sans  dark:text-darkWhite-300 py-4">
            <div className=" font-semibold text-2xl mx-auto">
              <Badge content="" color="success">
                <div className="md:text-2xl text-xl ">{number}</div>
              </Badge>

              <p className="md:text-sm text-base font-semibold opacity-40 mx-4">Aktif</p>
            </div>
            <div className=" font-semibold text-2xl mx-auto">
              <Badge content="" color="warning">
                <div className="md:text-2xl text-xl ">{number1}</div>
              </Badge>

              <p className="md:text-sm text-base font-semibold  opacity-40 mx-4">Pasif</p>
            </div>
            <div className=" font-semibold text-2xl mx-auto">
              <Badge content="" classNames={{
                  badge: ['bg-[#039BE5]', 'dark:bg-[#039BE5]']
                }} >
                <div className="md:text-2xl text-xl ">{number2}</div>
              </Badge>  

              <p className="md:text-sm text-base font-semibold  opacity-40 mx-4">Tamamlanan</p>
            </div>
            <div className=" font-semibold text-2xl mx-auto">
              <Badge content="" color="danger">
                <div className="md:text-2xl text-xl ">{number3}</div>
              </Badge>

              <p className="md:text-sm text-base font-semibold  opacity-40 mx-4">Toplam</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NumberComponent
